import { Component, Input, input } from '@angular/core';
import { ToastModule, ToastPositionType } from 'primeng/toast';

@Component({
  selector: 'app-toast',
  imports: [ToastModule],
  templateUrl: './toast.html',
  styleUrl: './toast.scss',
})
export class Toast {
  @Input() position: ToastPositionType = "center"

}
